React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_join_request_component')

module.exports = class extends React.Component
  _hasEnoughLicenses: ->
    @props.item.transferability.newBillableMembers?.length <= @props.dependencies.availableLicenses

  _renderManyMembers: t.renderable ->
    { item } = @props

    if item.transferability.newBillableMembers.length > 0
      translationKey = if item.membershipCount < 5
          switch item.transferability.newBillableMembers.length
            when 1 then 'request-user-count-2-to-4-has-1-new'
            when 2, 3, 4 then 'request-user-count-2-to-4-has-new-count-2-to-4'
            else 'request-user-count-2-to-4-has-new-count-many'
        else
          switch item.transferability.newBillableMembers.length
            when 1 then 'request-user-count-other-has-1-new'
            when 2, 3, 4 then 'request-user-count-other-has-new-count-2-to-4'
            else 'request-user-count-other-has-new-count-many'

      t.format translationKey, {
        current: item.membershipCount
        new: item.transferability.newBillableMembers.length
      }
    else
      translationKey = if item.membershipCount < 5
          'request-with-many-users-all-in-enterprise-count-2-to-4'
        else
          'request-with-many-users-all-in-enterprise-count-other'

      t.format translationKey,
        current: item.membershipCount

  _renderMemberCount: t.renderable ->
    { item } = @props

    if item.membershipCount == 1
      if item.transferability.newBillableMembers.length > 0
        t.format 'request-user-count-1-not-in-enterprise'
      else
        t.format 'request-user-count-1-is-in-enterprise'
    else
      @_renderManyMembers()

  _renderTransferrable: t.renderable ->
    if @_hasEnoughLicenses()
      @_renderMemberCount()
    else
      if @props.dependencies.availableLicenses?
        licensesNeeded = @props.item.transferability.newBillableMembers.length - @props.dependencies.availableLicenses

        key = switch licensesNeeded
          when 1 then 'not-enough-licenses-one'
          when 2, 3, 4 then 'not-enough-licenses-2-to-4'
          else 'not-enough-licenses-many'

        t.format key, { licensesNeeded }
      else
        @_renderMemberCount()
        t.br()
        t.text "You don't have enough licenses to add this team."

  render: t.renderable ->
    { item, dependencies: { availableLicenses }, eventHandlers } = @props
    {
      onViewUntransferredMembers,
      onViewNewBillableMembers,
      onDecline,
      onAccept
    } = eventHandlers

    classes = t.classify
      'non-transferrable': !item.transferability.transferrable
      'not-enough-licenses': !@_hasEnoughLicenses()
    t.div '.dashboard-list-item.pending-organization', class: classes, =>
      t.div '.options', =>
        t.b (el) ->
          onDecline(el, item)
        , ".option.button-link.role-button", ->
          t.format 'decline'

        if item.transferability.transferrable
          t.b (el) =>
            onAccept(el, item)
          , ".option.button-link.role-button"
          , class: t.classify(disabled: !@_hasEnoughLicenses())
          , disabled: !@_hasEnoughLicenses()
          , ->
            t.format 'accept'

      t.div '.member', ->
        if item.logoHash
          t.img '.member-avatar', src: [logoDomain, item.logoHash, '30.png'].join('/')
        else
          t.span '.team-of-member-image.icon-lg.icon-organization'

      t.div '.details', =>
        t.p '.name-line', ->
          t.span '.full-name', ->
            t.text item.displayName
        t.p '.u-bottom.quiet', =>
          t.span '.quiet.u-inline-block', =>
            if item.transferability.transferrable
              if item.transferability.newBillableMembers.length > 0
                t.b (el) =>
                  onViewNewBillableMembers(el, item)
                , =>
                  @_renderTransferrable()
              else
                @_renderTransferrable()
            else
              t.b (el) ->
                onViewUntransferredMembers(el, item)
              , ".option.quiet.non-transferrable-request", ->
                t.format 'non-transferrable-users'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/pending-organization-item-component.coffee